import React from 'react';
import './TermsAndConditions.css'; // Importing CSS for styling

function TermsAndConditions() {
  return (
    <div className="terms-container" style={{ position: "relative", zIndex: 1 , backgroundColor: "white"}}>
      <h1>Terms and Conditions</h1>
      <p>Amalgam Inc ("we", "our", or "us") values your privacy and is committed to being transparent about the technologies we use. Please read these Terms and Conditions carefully before using our services. By engaging with our consulting services or accessing our website, you ("client", "you", or "user") agree to be bound by these terms. If you do not agree to these terms, please do not use our services.</p>

      <h2>1. Scope of Services</h2>
      <p>Amalgam Inc provides web and software development consulting services, including but not limited to:</p>
      <ul>
        <li>Technical strategy consulting</li>
        <li>Custom software development</li>
        <li>UI/UX design</li>
        <li>Maintenance and support services</li>
      </ul>
      <p>Specific terms related to individual projects will be outlined in separate agreements or proposals.</p>

      <h2>2. Client Responsibilities</h2>
      <p>To enable us to provide the best service, clients agree to:</p>
      <ul>
        <li>Provide accurate and complete information about project requirements.</li>
        <li>Respond promptly to requests for approvals, feedback, or additional information.</li>
        <li>Ensure all content provided (text, images, code) is legally owned or properly licensed.</li>
      </ul>

      <h2>3. Intellectual Property</h2>
      <p>a) Pre-Existing Intellectual Property: Any pre-existing intellectual property owned by either party before entering the agreement remains the sole property of that party.</p>
      <p>b) Deliverables: Upon full payment, all deliverables created specifically for the client will be transferred to the client. However, Amalgam Inc retains the right to use general knowledge, skills, and methodologies developed during the project for future work.</p>

      <h2>4. Payment Terms</h2>
      <p>All fees for services will be outlined in a written agreement or invoice.</p>
      <p>Payment is due within [number of days] days of receiving the invoice unless otherwise specified.</p>
      <p>Late payments may be subject to a [percentage]% late fee or interest.</p>
      <p>In the event of non-payment, Amalgam Inc reserves the right to suspend or terminate services.</p>

      <h2>5. Confidentiality</h2>
      <p>Both parties agree to maintain the confidentiality of all proprietary information disclosed during the project, including but not limited to business strategies, product ideas, and technical specifications.</p>

      <h2>6. Limitation of Liability</h2>
      <p>To the fullest extent permitted by law, Amalgam Inc shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including loss of profits or business opportunities. Our total liability for any claim arising from our services shall not exceed the amount paid by the client for the specific project in question.</p>

      <h2>7. Termination of Services</h2>
      <p>Either party may terminate the agreement upon written notice if:</p>
      <ul>
        <li>The other party breaches a material term of the agreement and fails to remedy the breach within [number of days] days of notice.</li>
        <li>The project is delayed beyond a reasonable timeframe due to unforeseen circumstances.</li>
      </ul>
      <p>Upon termination, the client will be invoiced for all completed work up to the termination date.</p>

      <h2>8. Changes and Revisions</h2>
      <p>Any changes to the project scope may require a new proposal or additional fees. We will inform the client in advance of any additional costs and wait for written approval before proceeding with changes.</p>

      <h2>9. Third-Party Tools and Services</h2>
      <p>We may use third-party tools or services (e.g., cloud hosting, libraries, APIs) to deliver the project. While we strive to select reliable services, we are not responsible for issues caused by third-party providers.</p>

      <h2>10. Governing Law</h2>
      <p>These Terms and Conditions are governed by and construed in accordance with the laws of [Your Jurisdiction], without regard to conflict of law principles.</p>

      <h2>11. Dispute Resolution</h2>
      <p>In the event of a dispute, both parties agree to attempt to resolve the issue amicably through negotiation. If negotiations fail, disputes will be resolved through binding arbitration in [City, State/Country].</p>

      <h2>12. Amendments to Terms</h2>
      <p>We reserve the right to update or modify these Terms and Conditions at any time. Changes will be effective upon posting the revised terms on our website. Continued use of our services after such changes constitutes acceptance of the new terms.</p>

      <h2>13. Contact Information</h2>
      <p>If you have any questions or concerns about these Terms and Conditions, please contact us at:</p>
      <p>Amalgam Inc</p>
      <p>Email: hello@amalgam-inc.com</p>
    </div>
  );
}

export default TermsAndConditions; 